import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { TranslocoService } from '@jsverse/transloco';

import { SPA_DIALOG, SpaModal } from '@services';

import { ModalComponentButtonConfig } from '../modal/modal.component';

@Component({
  selector: 'spa-logout-dialog',
  templateUrl: './logout-dialog.component.html',
  styleUrls: ['./logout-dialog.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutDialogComponent {
  private modal = inject<SpaModal<boolean>>(SPA_DIALOG);
  private translocoService = inject(TranslocoService);

  buttons: ModalComponentButtonConfig[] = [
    {
      dataTestID: 'cancel_button',
      label: this.translocoService.translate('label.button.cancel'),
      primary: false,
      action: () => {
        this.modal.close(false);
      },
    },
    {
      dataTestID: 'confirm_button',
      label: this.translocoService.translate('label.button.logout'),
      primary: true,
      action: () => {
        this.modal.close(true);
      },
    },
  ];
}
